<section class="container" [ngClass]="{ 'container--sidenav-opened': menuOpened.sidenavOpened && !isMobile }">
	<div class="container__header">
		<button (click)="this.location.back()" class="back-button">
			<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
			Voltar
		</button>

		<h3 class="title">Meus dados</h3>
	</div>

	<ul *ngIf="client$ | async as client" class="container__form">
		<!-- Nome -->
		<li>
			<p>Nome</p>

			<div class="input">
				<span>{{ client.fullName }}</span>
			</div>
		</li>

		<!-- Email -->
		<li>
			<p>E-mail</p>

			<div class="input">
				<span>{{ client.email }}</span>
			</div>
		</li>

		<!-- Telefone -->
		<li>
			<p>Telefone</p>

			<div class="input">
				<span>{{ client.phone ? (client.phone | mask: '+99 (99) 99999-9999') : '' }}</span>
			</div>
		</li>

		<!-- CPF -->
		<li>
			<p>CPF</p>

			<div class="input">
				<span>{{ client.cpf }}</span>
			</div>
		</li>

		<!-- BIN -->
		<li>
			<p>BIN Cadastrado</p>

			<div class="input">
				<span>{{ client.categories[0].bin }}</span>
			</div>
		</li>
	</ul>
</section>
